export var INTAKE_SITE_STAGING = 'datad0g.com';
export var INTAKE_SITE_US1 = 'datadoghq.com';
export var INTAKE_SITE_AP1 = 'ap1.datadoghq.com';
export var INTAKE_SITE_US1_FED = 'ddog-gov.com';
//# sourceMappingURL=intakeSites.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@datadog/browser-core/esm/domain/configuration/intakeSites.js
// module id = 621
// module chunks = 0